const RefundDone = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="2 9.102448463439941 58.97520446777344 45.897552490234375"
        width="25"
        height="25"
    >
        <g>
            <g data-name="45 Refund">
                <path
                    fill="#8bc34a"
                    d="M58 25H5a3 3 0 0 0-3 3v24a3 3 0 0 0 3 3h50a3 3 0 0 0 3-3z"
                    opacity={1}
                    data-original="#8bc34a"
                />
                <path
                    fill="#689f38"
                    d="M54 29H9.946A.975.975 0 0 0 9 30.017 2.003 2.003 0 0 1 7.017 32 .975.975 0 0 0 6 32.946v14.108A.975.975 0 0 0 7.017 48 2.003 2.003 0 0 1 9 49.983.975.975 0 0 0 9.946 51h40.108A.975.975 0 0 0 51 49.983 2.003 2.003 0 0 1 52.983 48 .975.975 0 0 0 54 47.054z"
                    opacity={1}
                    data-original="#689f38"
                />
                <g fill="#8bc34a">
                    <path
                        d="M30 32c-10.666.187-10.668 15.812 0 16 10.666-.187 10.667-15.812 0-16zM45 37a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM16 37a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
                        fill="#8bc34a"
                        opacity={1}
                        data-original="#8bc34a"
                    />
                </g>
                <path
                    fill="#ff3c38"
                    d="M58.748 26.4c-3.04-5.24-9.009-8.607-17.748-10.016v-6.29a1.006 1.006 0 0 0-1.707-.707l-12.79 12.789a1 1 0 0 0 0 1.414l12.79 12.789A1.006 1.006 0 0 0 41 35.672v-6.347c7.81-.295 15.15 9.859 15.892 15.76a1.005 1.005 0 0 0 1.925.283c2.023-5.113 3.653-12.556-.069-18.969z"
                    opacity={1}
                    data-original="#ff3c38"
                    className=""
                />
                <path
                    fill="#689f38"
                    d="M30.368 39.004v-2.16a1.01 1.01 0 0 1 .788 1.005.3.3 0 0 0 .298.265h1.055a.302.302 0 0 0 .3-.303 2.485 2.485 0 0 0-2.44-2.523v-.56c0-.452-1.217-.451-1.216 0v.554a2.59 2.59 0 0 0 0 5.17v2.502c-.733-.194-.98-.66-.988-1.514a.3.3 0 0 0-.3-.3h-1.05a.3.3 0 0 0-.3.3 2.727 2.727 0 0 0 2.637 3.062v.819c0 .451 1.216.452 1.216 0v-.839c3.495-.42 3.641-4.984 0-5.478zm-1.216-.229a1 1 0 0 1 0-1.962zm1.857 3.89a1.345 1.345 0 0 1-.64.326v-2.232a1.136 1.136 0 0 1 .64 1.906z"
                    opacity={1}
                    data-original="#689f38"
                />
            </g>
        </g>
    </svg>
);
export default RefundDone;
